import { makePersistenceHandles } from '@castlery/shared-persistence-kit';
import { EcEnv, EC_COUNTRIES_ENUM } from '@castlery/config';

export const defaultDeniedRegions: string[] = [EC_COUNTRIES_ENUM.Enum.CA, EC_COUNTRIES_ENUM.Enum.UK];

export const isDefaultDeniedConsent = () => {
  return defaultDeniedRegions.includes(EcEnv.NEXT_PUBLIC_COUNTRY);
};

export const getRegionalDefaultConsent = (region: string) => {
  const upperCaseRegion = region.toUpperCase() as any;
  if (defaultDeniedRegions.includes(upperCaseRegion)) {
    return {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted',
    };
  }
  return {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    analytics_storage: 'granted',
    functionality_storage: 'granted',
    personalization_storage: 'granted',
    security_storage: 'granted',
  };
};
export function getConsentCookie(key: string, consentValue: string) {
  const cookieConsent = consentValue;
  if (!cookieConsent) return '';

  const { [key]: value } = cookieConsent.split(',').reduce((obj: Record<string, string>, pair: any) => {
    pair = pair.split(':');
    obj[pair[0]] = pair[1];
    return obj;
  }, {});
  return value === 'yes' ? 'granted' : 'denied';
}

export function getConsent() {
  // cookieyes-consent 的 key 和 value 的映射关系
  // https://www.cookieyes.com/documentation/implementing-google-consent-mode-using-cookieyes/#Google_Con_8
  const consentToCookieKeysMapping = {
    ad_storage: 'advertisement',
    ad_user_data: 'advertisement',
    ad_personalization: 'advertisement',
    analytics_storage: 'analytics',
    functionality_storage: 'functional',
    personalization_storage: 'functional',
    security_storage: 'necessary',
  };

  const isCookieYesEnabled = EcEnv.NEXT_PUBLIC_COOKIEYES_ENABLED;
  const regionalDefaultConsent = getRegionalDefaultConsent(EcEnv.NEXT_PUBLIC_COUNTRY);
  const consentValue = makePersistenceHandles().cookieConsent.getItem() ?? '';
  const result = Object.entries(regionalDefaultConsent)
    .map(([key, value]) => {
      const cookieKey = consentToCookieKeysMapping[key as keyof typeof consentToCookieKeysMapping];
      const cookieValue = getConsentCookie(cookieKey, consentValue) ?? '';
      return `${key}: '${isCookieYesEnabled ? cookieValue || value : value}'`;
    })
    .join(',\n  ');
  return result;
}
